import "./staff.css";
import {
  Container,
  Card,
  Col,
  Row,
  Image,
} from "react-bootstrap";
// import axios from 'axios';
import React, { useState } from "react";
import Add from './add/add';
// import Amend from './amend/amend';
import UpdateDentist from './amend/update/update'
import {FaRegPlusSquare} from "react-icons/fa";
import ReactGA from 'react-ga';

export default function Staff(props) {
  ReactGA.pageview(window.location.pathname + window.location.search);    
  console.log(props)

  const [showAdd, setShowAdd] = useState(false);
  const [showAmend, setShowAmend] = useState(false);
  const [dentist, setDentist] = useState(null);

  const clinicData = props.location.state.clinicData;
  const dentists = clinicData.dentists || [];
  const backup_picture_url ="https://upload.wikimedia.org/wikipedia/commons/thumb/a/ac/No_image_available.svg/600px-No_image_available.svg.png"

  const updateDentist = (dentist) => {
    setShowAmend(false)
    setDentist(dentist)
    setShowAdd(false)
    setShowAmend(true)
  };

  const addDentist = () => {
    setShowAmend(false)
    setShowAdd(true)
  };

return (
    
    <Container className="mt-2">
      <Card className='mb-2'>
        <Card.Header className='font-weight-bold'>
          Providers at your clinic
          <FaRegPlusSquare style={{ fill : 'green', width: '32px', height:'32px', cursor: 'pointer'}} className="float-right" onClick={() => addDentist()}/>
        </Card.Header>
            <Card.Body>
              <Row sm={2} md={3} lg={4}>
                  {dentists.map(dentist => (
                    <Col key={dentist._id} sm={5} md={3} lg={2} className='text-center'> 
                        <Image id='clickable' onClick={() => updateDentist(dentist)} style={{'width':'55px', 'height':'55px', cursor: 'pointer'}} className='border' src={`${dentist.picture_url || backup_picture_url}`} roundedCircle fluid/>
                        <Card.Text id='clickable' onClick={() => updateDentist(dentist)} style={{'fontSize':'12px', cursor: 'pointer'}} className='mb-0 text-align'>
                                {dentist.full_name}
                        </Card.Text>
                        <Card.Text id='clickable' onClick={() => updateDentist(dentist)} style={{'fontSize':'11px', cursor: 'pointer'}} className='mb-0 '>
                                {dentist.work_title}
                        </Card.Text>
                    </Col>
                  ))}
                </Row>
              </Card.Body>
          </Card>
          {showAdd &&
          <Add clinicData={clinicData}/>}
          {showAmend &&
          <UpdateDentist key={dentist._id} clinicData={clinicData} dentist={dentist}/>}
    </Container>



);
}

